import { useEffect, useState } from 'react';

import { Row, Col, GRID, WordCloud } from '../components/custom';

import { colorArray, colors, accentColor } from '../const';

import {
    BarChart,
    Bar,
    Rectangle,
    XAxis,
    YAxis,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    Legend,
    Cell
} from 'recharts';

const data =
{
    alpha: 0.05,
    chivalue: 3.02,
    dof: 2,
    expected:[[60.16, 65.83],[63.98, 70.02],[66.85, 73.15]],
    pvalue: 0.22,
    real:[[55, 71],[61, 73],[75, 65]],

    x:['Rural', 'Suburban', 'Urban'],
    y:['Female', 'Male']
}

function truncate(value, limiter)
{
    const limit = Math.floor(45 / limiter);

    const str = String(value);

    if (str.length < limit) return str;

    return `${str.substring(0, limit)}...`;
};

export default function Tool()
{
    function GiveGraphs()
    {
        const component = [];

        ['real', 'expected'].forEach((key) =>
        {
            const temp = [];

            for (let i = 0; i < data.x.length; i++)
            {
                const y = {};

                for (let j = 0; j < data.y.length; j++) y[data.y[j]] = data[key][i][j];

                temp.push({
                   x: data.x[i],
                    ...y
                });
            }

            component.push(<span key={Math.random()} className='descsmall'>{key === 'real' ? 'Actual Count' : 'Expected Count'}</span>);

            const bars = [];

            let i = 0;
    
            for (const ykey in temp[0])
            {
                if (ykey === 'x') continue;

                bars.push(
                    <Bar
                        key={Math.random()}
                        dataKey={ykey}
                        fill={colorArray[i]}
                        barSize={25}
                        className='bar'
                        activeBar={<Rectangle fill='white' stroke={colorArray[i]} strokeWidth={2}/>}/>
                );

                i++;
            }

            component.push(
                <ResponsiveContainer key={Math.random()} height='100%' width='100%' className='chart'>
                    <BarChart data={temp} layout='horizontal'>
                        <Tooltip/>
                        <CartesianGrid strokeDasharray='5'/>
                        <XAxis dataKey='x' fontSize={15} type='category' tickFormatter={(value) => truncate(value, temp.length)} padding={{left: 20, right: 20}}/>
                        <YAxis fontSize={15} type='number'/>
                        {bars}
                        <Legend/>
                    </BarChart>
                </ResponsiveContainer>
            );
        });

        component.push(
            <GRID key={Math.random()} style={{fontSize: '1vw', gridTemplate: `repeat(4, auto) / repeat(2, auto)`}}>
                <span className='bold left'>Chi-Value</span>
                <span>{data.chivalue}</span>
                <span className='bold left'>P-Value</span>
                <span>{data.pvalue}</span>
                <span className='bold left'>Alpha Value</span>
                <span>{data.alpha}</span>
                <span className='bold left'>Degree of Freedom</span>
                <span>{data.dof}</span>
            </GRID>
        );

        return component;
    }
    
    return (
        <Col id='test' style={{height: '100%', width: '50%', margin: '10vh 0'}}>
            <Col className='wrapper'>
                {GiveGraphs()}
            </Col>
        </Col>
    )
}